import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'

/** Während des Mount-Bootstraps (Token-Prüfung/`me()`) noch nichts rendern, damit
 *  kein verfrühter Redirect zur Login-Seite passiert, bevor die Session bekannt ist.
 *  `anon` → zurück zum bereichseigenen Login (F2-Split: /admin/login bzw.
 *  /editor/login), Ursprung als `from` gemerkt. `authed` → Outlet. */
export function RequireAuth() {
  const { status } = useAuth()
  const location = useLocation()
  if (status === 'loading') {
    return null
  }
  if (status === 'anon') {
    const loginPath = location.pathname.startsWith('/admin') ? '/admin/login' : '/editor/login'
    return <Navigate to={loginPath} replace state={{ from: location }} />
  }
  return <Outlet />
}
